<template>
  <div class="d-flex justify-end">
    <v-menu
      v-model="menu"
      offset-y>
      <template #activator="{ value }">
        <sButton
          class=" py-1 px-2 h7-text-medium group-menu-btn"
          :color="value ? '#000000a6' : 'var(--black-color)'"
          data-qa="group-menu-btn"
          type="text"
          @click="menu = true">
          {{ $t('Tenders.ToGroup') }}: {{ current.text }}
          <sIcon
            class="ml-2 my-auto"
            :rotate="value ? '-180' : '0'"
            size="10"
            type="arrow"/>
        </sButton>
      </template>
      <div
        class="filters-menu-list list menu"
        data-qa="group-menu">
        <div
          v-for="item in types"
          :key="item.text"
          :class="['group-menu-item h7-text px-4 py-3',
                   {'secondary__green_chosen h7-text-medium': mode.value == item.value && mode.isGroup === item.isGroup} ]"
          data-qa="group-menu-item"
          @click="mode = item">
          <span>
            {{ item.text }}
          </span>
          <sIcon
            v-if="mode.value == item.value && mode.isGroup === item.isGroup"
            size="8"
            type="okay-arrow"/>
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'groupMenu',
  data() {
    return {
      menu: false
    }
  },
  props: {
    /**
     * теперішній варіант
     * {text , value}
     */
    current: {
      type: Object,
      required: true
    },
    /**
     * масив можливих варіантів
     * [
     * {text , value},
     * {text , value}
     * ]
     */
    types: {
      type: Array,
      required: true
    },
  },

  computed: {
    mode: {
      get() {
        return this.current
      },
      set(value) {
        this.$emit('update:current', value )
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.group-menu-btn {
  text-transform: none !important;
}
.group-menu-item {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
